<template>
  <div class="row align-items-center">
      <div class="col-md-12 pl-4">
        <div class="input-group">
          <input 
            type="text" class="form-control" 
            :placeholder="$t('navbar.search.text')" 
            v-on:keyup.enter="simpleSearch"
            size="60"
          >
          <div class="input-group-append">
            <b-dropdown id="dropdown-lef" class="card-drop" variant="default">
              <template v-slot:button-content>
                <i class="bx bxs-down-arrow"></i>
              </template>

              <b-dropdown-item v-b-modal.modal-standard>
                {{ $t("navbar.search.metadata_search") }}
              </b-dropdown-item>

              <!-- <b-dropdown-item v-b-modal.modal-content-search>
                {{ $t("navbar.search.content_search") }}
              </b-dropdown-item> -->
            </b-dropdown>
          </div>
        </div>
      </div>                  
      <b-modal 
        id="modal-standard" :title="$t('navbar.search.modal_title')" 
        title-class="font-18" hide-footer v-model="showSearchModal">
        <label>{{ $t('navbar.search.docType_content_search') }}</label>
        <select class="form-control mb-2" v-model="documentType">
          <option v-for="docType in documentTypes"  :value="docType" 
            :key="docType.id">{{ docType.name }}</option>
        </select>            
        <form @submit.prevent="advancedSearch" v-if="isCharged">
          <h5 class="mb-4">{{ $t('navbar.search.metadata_title') }} :  </h5>
          <div class="alert alert-danger" v-if="showMetadataAlert">
            {{ $t('navbar.search.content_instruction') }}
          </div>  
          <hr>
          <div  v-for="data in metadata" :key="data.id" class="mb-3">
            <label :for="data.id">{{ data.label}} contient :</label> <br>
            <input v-model="data.searchText" type="text" 
              class="form-control" v-if="data.type == 'string'" :id="data.id" :maxlength="10" />
            <input type="number" v-if="data.type == 'number'" 
              class="form-control" v-model="data.searchText" :id="data.id">
            <input type="date" v-if="data.type == 'date'" 
              class="form-control" v-model="data.searchText" :id="data.id">
            <textarea v-if="data.type == 'text'" v-model="data.searchText" :id="data.id" rows="2" 
              class="form-control"></textarea>
          </div>
          <div class="text-right">
            <input type="submit" class="btn btn-primary" value="Rechercher">
          </div>
        </form>                
      </b-modal>
      <b-modal id="modal-content-search" title="Recherche par contenu" hide-footer  title-class="font-18" v-model="showSearchContent">
        <form @submit.prevent="searchByContent">
          <div class="form-group">
            <label for="content">Contenu de la recherche</label>
            <textarea class="form-control" v-model="searchText" placeholder="Le contenu de votre recherche" id="" cols="30" rows="4"></textarea>
          </div>
          <div class="text-right">
            <input type="submit" class="btn btn-primary" value="Rechercher">
          </div>
        </form>
      </b-modal>                        
  </div>
</template>

<script>
import EventBus from '../eventBus';
import { mapActions } from "vuex";


export default {
  data() {
    return {
      documentType: null,
      documentTypes: [],
      metadata: [],
      isCharged: false,
      showSearchModal: false,
      showSearchContent: false,
      showMetadataAlert: false,
      searchText : ""
    }
  },
  computed: {
    breadcrumb() {
      return this.$store.getters[`${this.activeManager}/breadcrumb`];
    },
    /**
     * Active manager name
     * @returns {default.computed.activeManager|(function())|string|activeManager}
     */
    activeManager() {
      return this.$store.state.activeManager;
    },

    // Panel status - visible or hidden
    showPanel() {
      return this.$store.state.left.showFileDetail;
    },

    /**
     * Back button state
     * @returns {boolean}
     */
    backDisabled() {
      return !this.$store.state.activeManager.historyPointer;
    },

    /**
     * Forward button state
     * @returns {boolean}
     */
    forwardDisabled() {
      return this.$store.state.activeManager.historyPointer
          === this.$store.state.activeManager.history.length - 1;
    },

    /**
     * Is any files or directories selected?
     * @returns {boolean}
     */
    isAnyItemSelected() {
      return this.$store.state.activeManager.selected.files.length > 0
          || this.$store.state.activeManager.selected.directories.length > 0;
    },

    /**
     * Manager view type - grid or table
     * @returns {default.computed.viewType|(function())|string}
     */
    viewType() {
      return this.$store.state.activeManager.viewType;
    },

    /**
     * Upload files
     * @returns {boolean}
     */
    uploading() {
      return this.$store.state.messages.actionProgress > 0;
    },

    /**
     * Clipboard - action type
     * @returns {null}
     */
    clipboardType() {
      return this.$store.state.clipboard.type;
    },

    /**
     * Full screen status
     * @returns {default.computed.fullScreen|(function())|boolean|fullScreen|*|string}
     */
    fullScreen() {
      return this.$store.state.fullScreen;
    },

    /**
     * Show or Hide hidden files
     * @returns {boolean}
     */
    hiddenFiles() {
      return this.$store.state.settings.hiddenFiles;
    },

    /**
     * Spinner
     * @returns {number}
     */
    loadingSpinner() {
      return this.$store.state.messages.loading;
    },

  },

  watch: {
    documentType: function() {
      this.isCharged = true;
      this.getDocumentTypeMetadas(this.documentType.id).then((response) => {
        this.metadata = response.data.Metadata
      })
    }
  },
  methods: {
    ...mapActions(["getDocumentTypes", "getDocumentTypeMetadas", "advancedSearch"]),
    
    simpleSearch(event) {
      let searchText = event.target.value
      if (searchText.length === 0) {
        this.selectMainDirectory();
      }

      if (searchText.length >= 3) {
        const searchPayload = {
          type: 'simple',
          searchText,          
        }
        this.search(searchPayload);        
      }
    },

    searchByContent() {
      let searchPayload = {
        filter:  this.searchText,
        type: 'content'
      }
      this.search(searchPayload);
      this.showSearchContent = false;
      this.searchText = "";
    },
    
    advancedSearch() {
      const metadata = this.metadata.map((mdata) => {
        if ('searchText' in mdata) {
          return { id: mdata.id, text: mdata.searchText }
        } else {
          return { id: mdata.id, text: "" }
        }
      })
      if (metadata.filter((e) => e.text !== "").length > 0) {
        const searchPayload = {
          type: 'advanced',
          documentTypeId: this.documentType.id,
          metadatas: metadata.filter((e) => e.text !== "")
        }
        this.showSearchModal = false;
        this.showMetadataAlert = false;
        this.search(searchPayload);
      } else {
        this.showMetadataAlert = true;
      }
    },

    /**
     * Load selected directory and show files
     * @param path
     */
    selectDirectory(path) {
      this.$store.dispatch(`${this.activeManager}/selectDirectory`, { path, history: true });
    },

    selectMainDirectory() {
      this.$store.dispatch(`${this.activeManager}/selectDirectory`, { path: null, history: true });
    },

    /**
     * Search for files and folders
     * @param {*} searchPayload 
     */
    search(searchPayload) {
      this.$store.dispatch(`${this.activeManager}/search`, { searchPayload });
    },


    /**
     * Refresh file manager
     */
    refreshAll() {
      this.$store.dispatch('refreshAll');
    },

    /**
     * History back
     */
    historyBack() {
      this.$store.dispatch(`${this.activeManager}/historyBack`);
    },

    /**
     * History forward
     */
    historyForward() {
      this.$store.dispatch(`${this.activeManager}/historyForward`);
    },

    /**
     * Copy
     * @param type
     */
    toClipboard(type) {
      this.$store.dispatch('toClipboard', type);

      // show notification
      if (type === 'cut') {
        EventBus.$emit('addNotification', {
          status: 'success',
          message: this.lang.notifications.cutToClipboard,
        });
      } else if (type === 'copy') {
        EventBus.$emit('addNotification', {
          status: 'success',
          message: this.lang.notifications.copyToClipboard,
        });
      }
    },

    /**
     * Paste
     */
    paste() {
      this.$store.dispatch('paste');
    },

    /**
     * Set Hide or Show hidden files
     */
    toggleHidden() {
      this.$store.commit('settings/toggleHiddenFiles');
    },
     
    /**
     * Show modal window
     * @param modalName
     */
    showModal(modalName) {
      // show selected modal
      this.$store.commit('modal/setModalState', {
        modalName,
        show: true,
      });
    },

    /**
     * Select view type
     * @param type
     */
    selectView(type) {
      if (this.viewType !== type) this.$store.commit(`${this.activeManager}/setView`, type);
    },
  },
  mounted() {
    this.$store.commit(`${this.activeManager}/setView`, 'grid');
  },
  created() {
    this.getDocumentTypes().then((response) => {
      this.documentTypes = response.data.data
    }).catch(() => {
      
    } );
  }
};
</script>

<style lang="scss" scoped>
    .fm-navbar {

        .btn-group {
            margin-right: 0.4rem;
        }
    }
    .dropdown-icon-item {
      cursor: pointer;
    }

    .input-group {
      background-color: #f1f5fa !important;
      border-radius: 8px;
    }
    .form-control {
      background-color: #f1f5fa;
    }
    
</style>
